<template>
  <div class="chosen-filters" v-if='hasSimpleOrComponentFilters'>
    <ul>
      <li v-for='(v, k) in componentFilters' :key='k'>
        <span @click.prevent='currentFilter = queryToFilter(k)'>
          {{ $t('root.filters.' + queryToFilter(k)) }}
          <strong>{{ valueToFilter(k, v) }}</strong>
        </span>

        <span @click.prevent.stop='resetFilter(k)' class="remove-item">x</span>

        <div class="edit-filter" v-show='currentFilter == queryToFilter(k)'>
          <component :is="'filter-items-by-' + queryToFilter(k)" @cancel='closeDropdown' />
          <span @click.prevent.stop='currentFilter = null' class="close-item">x</span>
        </div>
      </li>

      <li v-for='(v, k) in simpleFilters' :key='k'>
        <span>
          {{ $t('root.filters.' + queryToFilter(k)) }}
          <strong>{{ v }}</strong>
        </span>

        <span @click.prevent.stop='resetFilter(k)' class="remove-item">x</span>
      </li>
    </ul>

    <button @click.prevent='resetFilters' class="remove-filters own-tooltip own-tooltip-left" :data-tooltip="$t('root.filters.remove_all_filters')">
      <i class="fas fa-trash"></i>
    </button>
  </div>
</template>

<script>

import _filter_items_by_contact from './_filter_by_contact'
import _filter_items_by_tag from './_filter_by_tag'
import _filter_items_by_email from './_filter_by_email'
import _filter_items_by_progress from './_filter_by_checklist_progress'
import _filter_items_by_company from './_filter_by_company'
import _filter_items_by_contact_data_status from './_filter_by_contact_data_status'

export default {
  components: {
    'filter-items-by-id_in': _filter_items_by_contact,
    'filter-items-by-id_not_in': _filter_items_by_contact,
    'filter-items-by-tags_id_in': _filter_items_by_tag,
    'filter-items-by-tags_id_not_in': _filter_items_by_tag,
    'filter-items-by-email_in': _filter_items_by_email,
    'filter-items-by-email_not_in': _filter_items_by_email,
    'filter-items-by-contact_data_checklist_progress_gteq': _filter_items_by_progress,
    'filter-items-by-contact_data_checklist_progress_lteq': _filter_items_by_progress,
    'filter-items-by-company_in': _filter_items_by_company,
    'filter-items-by-company_not_in': _filter_items_by_company,
    'filter-items-by-contact_data_status_in': _filter_items_by_contact_data_status,
    'filter-items-by-contact_data_status_not_in': _filter_items_by_contact_data_status,
  },
  created() {
    this.loadFilterData()
  },
  watch: {
    query() {
      this.currentFilter = null
      this.loadFilterData()
    }
  },
  data() {
    return {
      currentFilter: null,
      contacts: [],
      tags: [],
    }
  },
  computed: {
    simpleFilters() {
      const fs = ['filters[content_cont]']
      const res = {}
      fs.forEach(f => {
        if (this.query[f])
          res[f] = this.query[f]
      })
      return res
    },
    componentFilters() {
      const f = {}
      Object.keys(this.query).forEach(k => {
        if (!this.simpleFilters[k] && k.indexOf('filters') >= 0 && k.indexOf('filters[s]') < 0)
          f[k] = this.query[k]
      })
      return f
    },
    hasSimpleOrComponentFilters() {
      return (Object.keys(this.componentFilters).length + Object.keys(this.simpleFilters).length) > 0
    },
    tagIds() {
      return this.query['filters[tags_id_in]'] || this.query['filters[tags_id_not_in]']
    },
    contactIds() {
      return this.query['filters[id_in]'] || this.query['filters[id_not_in]']
    },
  },
  methods: {
    queryToFilter(f) {
      return f.replace(/filters\[|\]/g, '')
    },
    valueToFilter(f, v) {
      if (f == 'filters[id_in]' || f == 'filters[id_not_in]')
        return this.intersectAndFormat(this.contacts, v)
      else if(f == 'filters[email_in]' || f == 'filters[email_not_in]' || f == 'filters[company_in]' || f == 'filters[company_not_in]')
        return this.contactAttFormat(v)
      else if (f == 'filters[tags_id_in]' || f == 'filters[tags_id_not_in]')
        return this.intersectAndFormat(this.tags, v)
      else if( f == 'filters[contact_data_status_in]' || f == 'filters[contact_data_status_not_in]')
        return this.formatCommunicationStatus(v)
      else if (Number(v))
        return v
      else
        return this.$t('root.filters.' + v)
    },
    resetFilter(f) {
      let newQuery = Object.assign({}, this.query)

      delete newQuery[f]

      if (Object.keys(this.componentFilters).length == 1)
        delete newQuery['parent_id']

      this.$router.push({ query: newQuery })
    },
    resetFilters() {
      this.$router.push({ query: {} })
    },
    intersectAndFormat(resources, v) {
      const ids = Array.isArray(v) ? v.map(x => parseInt(x)) : [parseInt(v)]
      return resources.filter(x => ids.indexOf(x.id) >= 0).map(x => x.name).join(', ')
    },
    contactAttFormat(v) {
      return v.join(', ')
    },
    formatCommunicationStatus(v) {
      if (!Array.isArray(v))
        return this.$t('root.filters.' + v)

      return v.map(x =>  this.$t('root.filters.' + x)).join(', ')
    },
    closeDropdown() {
      this.currentFilter = null
    },
    loadFilterData() {
      if (this.contactIds)
        this.listStore.getContacts({ 'filters[id_in]': this.contactIds }).then(({data}) => this.contacts = data)

      if (this.tagIds)
        this.listStore.getTags({ 'filters[id_in]': this.tagIds }).then(({data}) => this.tags = data)
    }
  }
}
</script>

<style lang='sass' scoped>
.chosen-filters
  float: left
  width: 100%
  margin: 10px 0
  display: flex
  position: relative
  ul
    margin: 0
    padding: 0
    list-style: none
    display: flex
    flex-wrap: wrap
    li
      border: 1px solid #c6c6c6
      border-radius: 3px
      width: auto
      padding: 3px 5px
      cursor: pointer
      margin-right: 10px
      position: relative
      margin-bottom: 5px
      .remove-item
        font-size: 18px
        padding-left: 10px
  .edit-filter
    position: absolute
    background: #fff
    border: 1px solid #c8c8c8
    top: 40px
    left: 0
    border-radius: 3px
    z-index: 1000
    padding: 10px
    &:after, &:before
      bottom: 100%
      left: 50%
      border: solid transparent
      content: ""
      height: 0
      width: 0
      position: absolute
      pointer-events: none
    &:after
      border-color: rgba(255, 255, 255, 0)
      border-bottom-color: #fff
      border-width: 10px
      margin-left: -10px
    &:before
      border-color: rgba(200, 200, 200, 0)
      border-bottom-color: #c8c8c8
      border-width: 13px
      margin-left: -13px
    .close-item
      position: absolute
      top: -2px
      right: 12px
      font-size: 18px
      cursor: pointer
  .remove-filters
    border: none
    background: #5072ED
    border-radius: 50%
    width: 25px
    height: 25px
    margin-top: 2px
    i
      color: #fff
</style>
